module.exports = RedNaoSharedCore.default('shared/core/Controls/FontAwesome/FontAwesomeIcon');